/// <reference types="grecaptcha" />

export type RecaptchaScriptParams = {
  hl?: string;
  isInvisible?: boolean;
  key?: string;
};

declare let window: Window & {
  grecaptcha_onload: () => void;
  grecaptcha: ReCaptchaV2.ReCaptcha;
};

export const loadScript = (
  scriptParams: RecaptchaScriptParams,
): Promise<ReCaptchaV2.ReCaptcha> =>
  doesSdkExist()
    ? Promise.resolve(getSdk())
    : new Promise(resolve => {
        window.grecaptcha_onload = () => {
          resolve(getSdk());
        };
        window.document.body.append(createRecaptchaScriptElement(scriptParams));
      });

function doesSdkExist() {
  return Boolean(getSdk());
}

function getSdk() {
  return window.grecaptcha;
}

function createRecaptchaScriptElement(scriptParams: RecaptchaScriptParams) {
  const { hl, isInvisible, key } = scriptParams;
  const script = window.document.createElement('script');
  script.defer = true;
  script.async = true;
  const sdkUrl = isInvisible
    ? 'https://www.google.com/recaptcha/enterprise.js'
    : 'https://www.google.com/recaptcha/api.js';
  const url = new URL(sdkUrl);
  if (hl) {
    url.searchParams.append('hl', hl);
  }
  url.searchParams.append('onload', 'grecaptcha_onload');
  const render = isInvisible && key ? key : 'explicit';
  url.searchParams.append('render', render);
  script.src = url.toString();
  return script;
}
